import { Injectable } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { UserService } from '../user/user.service';
import { SessionStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { SessionKeys } from 'src/app/shared/enums/session-keys.enum';

@Injectable({
  providedIn: 'root'
})
export class TimerService {
  private idle!: number;
  private timeout = 1;
  private ping = 1;
  private timeoutSub: any;

  constructor(
    private userIdle: UserIdleService,
    private userService: UserService,
    private sessionStorage: SessionStorageService,
    private router: Router,
    private dialog?: MatDialog,
  ) { }

  // *************************************************************** //
  // Start idle check after login
  // *************************************************************** //
  startCheck(timeoutMinutes: number) {
    // convert minutes → seconds
    this.idle = timeoutMinutes * 60;

    // stop any previous watchers before starting a new one
    this.stopWatch();

    // configure new watcher
    this.userIdle.setConfigValues({
      idle: this.idle,
      timeout: this.timeout,
      ping: this.ping
    });

    this.userIdle.startWatching();
    this.userIdle.onTimerStart().subscribe(count => {

    });

    // unsubscribe previous timeout listeners
    if (this.timeoutSub) {
      this.timeoutSub.unsubscribe();
    }

    // handle inactivity timeout
    this.timeoutSub = this.userIdle.onTimeout().subscribe(() => {
      console.log('🚨 onTimeout event triggered!');
      if (this.sessionStorage.retrieve('timerStarted') === true) {

        this.dialog?.closeAll();  // 👈 close all open dialogs
        // store last visited route
        const currentRoute = this.router.url;
        this.sessionStorage.store(SessionKeys.LastRoute, currentRoute);
        this.sessionStorage.store(SessionKeys.LastUser, this.sessionStorage.retrieve(SessionKeys.UserId));
        

        // clear session and logout
        this.userService.logOutonTimeout();

        Swal.fire({
          title: 'Session Expired',
          text: 'No activity detected. Please log in again.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });

        // cleanup session key
        this.sessionStorage.clear('timerStarted');
      }
    });
  }

  // *************************************************************** //
  stopWatch() {
    this.userIdle.stopWatching();
    this.userIdle.stopTimer();
    if (this.timeoutSub) {
      this.timeoutSub.unsubscribe();
    }
  }
}
